import { apiAuth } from "../../http";

export const getAuth = async (): Promise<any> => {
  const response = apiAuth()
    .get("/me")
    .then(({ data }) => data);
  return response;
};
